module.exports = __webpack_public_path__ + "static/media/thumbnail.fc0b3a8b.png";